export const USER_MAIL = 'USER_MAIL';
export const USER_MOB = 'USER_MOB';
export const USER_CURRENT_PROFILE = 'userCurrentProfile';
